<section>
    <header>
        <a routerLink="/basket-builder">
            <div class="logo"></div>
        </a>

        <div class="search" [ngClass]="searchText.length > 0 ? 'searching' : ''">
            <mat-form-field appearance="outline">
                <input matInput #searchInput type="text" placeholder="SEARCH" [(ngModel)]="searchText"
                    name="product-search" />
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
    </header>
</section>

<div *ngIf="searchText.length > 0" class="search-results">
    <component-header-search [searchInput]="searchInput" [searchText]="searchText" (closeSearch)="closeSearch()"></component-header-search>
</div>

<div class="breadcrumbs" [ngClass]="{ active: showBackButton }">
    <button mat-stroked-button color="secondary" class="skinny" routerLink="/basket-builder">
        <mat-icon>menu</mat-icon> Menu
    </button>
</div>